function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { asSingleStyleConfig } from '../../utils/theme';
import { textStyles } from '../foundations/typography';
export default asSingleStyleConfig({
  baseStyle: {
    '& > :last-child': {
      mb: 0
    },
    h1: _objectSpread(_objectSpread({}, textStyles['heading-lg']), {}, {
      mb: 8
    }),
    h2: _objectSpread(_objectSpread({}, textStyles['heading-md']), {}, {
      mb: 6
    }),
    h3: _objectSpread(_objectSpread({}, textStyles['heading-sm']), {}, {
      mb: 4
    }),
    h4: _objectSpread(_objectSpread({}, textStyles['lead-sm']), {}, {
      mb: 3
    }),
    h5: _objectSpread(_objectSpread({}, textStyles['body-xs']), {}, {
      mb: 3
    }),
    p: {
      fontSize: ['sm', 'md'],
      lineHeight: ['short', 'base'],
      mb: 5
    },
    a: {
      fontWeight: 'semibold',
      color: 'blue.600',
      fontSize: ['sm', 'md'],
      lineHeight: ['short', 'base']
    },
    ul: {
      listStyle: 'none',
      mb: 6
    },
    'ul li': {
      position: 'relative',
      fontSize: ['sm', 'md'],
      lineHeight: ['short', 'base'],
      pl: [6, 8],
      '&:not(:last-child)': {
        mb: 6
      },
      _before: {
        content: '""',
        width: '.5em',
        height: '.5em',
        bg: 'blue.600',
        position: 'absolute',
        left: 0,
        top: '.5em',
        borderRadius: '50%'
      }
    },
    ol: {
      listStyle: 'none',
      counterReset: 'list-number',
      mb: 6
    },
    'ol li': {
      position: 'relative',
      fontSize: ['sm', 'md'],
      lineHeight: ['short', 'base'],
      pl: [6, 8],
      '&:not(:last-child)': {
        mb: 6
      },
      _before: {
        counterIncrement: 'list-number',
        content: 'counter(list-number)',
        fontSize: 'sm',
        fontWeight: 'semibold',
        color: 'white',
        h: 6,
        w: 6,
        borderRadius: '50%',
        position: 'absolute',
        top: 0,
        left: '-.5em',
        bg: 'blue.600',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }
  }
});